import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=6f700c80&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=ts"
export * from "./SideDrawer.vue?vue&type=script&lang=ts"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=6f700c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f700c80",
  null
  
)

export default component.exports